import { useState, MouseEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { StrictFormSelectProps } from 'semantic-ui-react'

import { Icon } from '@/ui'
import { StyledSelect, AngleDownIcon } from './Styles'

export interface SelectProps extends Omit<StrictFormSelectProps, 'value'> {
  value?: StrictFormSelectProps['value'] | null
  sensitive?: boolean
  onSensitiveToggle?: (e: MouseEvent, visible: boolean) => void
}

export default function Select({
  value,
  sensitive,
  disabled,
  onSensitiveToggle,
  search = true,
  selectOnBlur = false,
  ...props
}: SelectProps) {
  const [visible, setVisible] = useState(false)

  const { t } = useTranslation()

  const Input = (
    <StyledSelect
      value={value}
      disabled={disabled}
      search={search}
      selectOnBlur={selectOnBlur}
      noResultsMessage={
        props.loading ? `${t('Loading')}...` : t('No results found')
      }
      {...props}
    />
  )

  if (sensitive) {
    return (
      <div title={t('Toggle content')} style={{ position: 'relative' }}>
        {visible ? (
          Input
        ) : (
          <>
            <input
              disabled
              value="**********"
              style={{
                height: '35px',
                background: !disabled ? '#fff' : undefined,
              }}
            />

            {!disabled && <AngleDownIcon />}
          </>
        )}

        <Icon
          button
          size="big"
          name={visible ? 'icon-sensitive-off' : 'icon-sensitive-on'}
          onClick={e => {
            onSensitiveToggle?.(e, !visible)
            setVisible(!visible)
          }}
          style={{
            position: 'absolute',
            right: disabled ? '8px' : '24px',
            top: '8px',
          }}
        />
      </div>
    )
  }

  return Input
}
